import {stringify} from 'qs'
import request from 'crm/utils/request'
import api from 'crm/common/api/drainage-channel-manage'

export async function getTableData(params) {
    return request(`${api.getTableData.url}?${stringify(params)}`)
}

export async function downloadTemplate() {
    // 加时间戳参数，防止浏览器缓存
    return request(`${api.downloadTemplate.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}

export async function importGroupLink(payload) {
    return request(api.importGroupLink.url, {
        method: api.importGroupLink.type,
        body: payload.body,
    })
}

export async function downloadStoreGroupTemplate() {
    // 加时间戳参数，防止浏览器缓存
    return request(`${api.downloadStoreGroupTemplate.url}?t=${new Date().getTime()}`, null, {
        returnResponse: true,
    })
}

export async function importStoreGroup(payload) {
    return request(api.importStoreGroup.url, {
        method: api.importStoreGroup.type,
        body: payload.body,
    })
}
